export class FieldValue {
    GROUP: string;
    FIELD: string;
    VALUE: string | object | number;
    REFRESH?: string;

    static parse(json: any): FieldValue {
        if (json) {
            const fv = new FieldValue();

            fv.GROUP = json.GROUP;
            fv.FIELD = json.FIELD;
            fv.VALUE = json.VALUE;
            fv.REFRESH = json.REFRESH;

            return fv;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FieldValue> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FieldValue.parse(j));

        return arr;
    }
}

export class FieldGroupValue {
    GROUP: string;
    FIELD_LIST: Array<FieldList>;

    static parse(json: any): FieldGroupValue {
        if (json) {
            const fgv = new FieldGroupValue();

            fgv.GROUP = json.GROUP;
            if (json.FIELD_LIST)
                fgv.FIELD_LIST = FieldList.parseArray(json.FIELD_LIST);

            return fgv;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FieldGroupValue> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FieldGroupValue.parse(j));

        return arr;
    }
}

export class FieldList {
    FIELD: string;
    VALUE: string | any;

    static parse(json: any): FieldList {
        if (json) {
            const fv = new FieldList();

            fv.FIELD = json.FIELD;
            fv.VALUE = json.VALUE;

            return fv;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FieldList> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FieldList.parse(j));

        return arr;
    }
    
}


export class FieldValueReset {
    GROUP: string;
    FIELD_LIST: Array<string>;

    static parse(json: any): FieldValueReset {
        if (json) {
            const fv = new FieldValueReset();

            fv.GROUP = json.GROUP;
            fv.FIELD_LIST = json.FIELD;

            return fv;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<FieldValueReset> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(FieldValueReset.parse(j));

        return arr;
    }
}